var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreloader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "20 29 60 40",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "#fff",
    cx: 29.883,
    cy: 48.438,
    r: 5.969
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0.1,
    values: "0;1;0",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "#fff",
    cx: 49.522,
    cy: 48.438,
    r: 5.969
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0.2,
    values: "0;1;0",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0,
    fill: "#fff",
    cx: 68.199,
    cy: 48.438,
    r: 5.969
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0.3,
    values: "0;1;0",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreloader);
export default __webpack_public_path__ + "static/media/preloader.3795dbae6b3c7f3959324adb3c43a267.svg";
export { ForwardRef as ReactComponent };